import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const CookiesPolicy = () => {
  return (
    <div className="policy-page">
      {/* Hero Banner */}
      <section className="policy-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1>Cookies Policy</h1>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <figure className="policy-image">
                <img src="/assets/images/data-protection.svg" alt="Cookies Policy" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-content-inner">
            <p>
              To enhance your experience and make it worth of your while,
              this website uses cookies. When you visit Dive-in Panels
              website, a web server sends a cookie (small text files) to
              your system or mobile device to store and track valuable
              information. In short, Cookies further makes a user's
              experience more efficient.
            </p>

            <p>
              We use cookies to make the Dive-in Panels website easier to use,
              to deliver a personalised experience on our websites, and to
              better tailor our products, services and websites to your
              interests and needs. Cookies are used to help speed up your
              future activities and your experience on our website. The
              law states that we can store cookies on your device if they
              are strictly necessary for the operation of this site.
            </p>

            <h3>
              The cookies used on Dive-in Panels website may be generally
              categorised as follow:
            </h3>

            <ul className="policy-list">
              <li>
                <strong>Necessary Cookies.</strong> These cookies do not identify you as an
                individual.
              </li>
              <li>
                <strong>Performance Cookies.</strong> These cookies do not identify you as
                an individual.
              </li>
              <li>
                <strong>Functionality Cookies.</strong> The information these cookies
                collect may include personal data that you have disclosed.
              </li>
              <li>
                <strong>Targeting or Advertising Cookies.</strong> Most types of these
                cookies track consumers via their Device ID or IP address
                therefore they may collect personal data.
              </li>
              <li>
                <strong>Third-Party Cookies.</strong> Based on the type of cookies used by
                the relevant third-party, the information these cookies
                collect may include personal data.
              </li>
            </ul>

            <h3>
              For all other types of cookies we need your permission.
            </h3>

            <p>
              If you have any further queries on our cookie policy then
              please <Link to="/contact-us">Contact Us.</Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiesPolicy;

